import { Box, Typography, useTheme } from "@mui/material";
import { mainBg } from "../../config/constants";
import { getIsLightColor } from "../../shared/getIsLightColor";

const ModalHeader = ({
  primaryText,
  secondaryText,
  sx,
  imgStyle,
  children,
  removeTitleSpace,
}) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        zIndex: -1,
        overflow: "hidden",
        height: "109px",
        minHeight: "109px",
        position: "relative",
        display: "flex",
        alignItems: "center",
        alignContent: "center",
        justifyContent: "center",
        ...sx,
      }}
    >
      <img
        src={mainBg}
        style={{
          position: "absolute",
          width: "100%",
          height: "100%",
          objectFit: "cover",
          objectPosition: "center 45%",
          zIndex: -1,
          ...imgStyle,
        }}
        alt=""
      />
      <Box sx={{ width: 1, textAlign: "center" }}>
        <Typography
          fontWeight="bold"
          variant="h6"
          color={
            getIsLightColor(theme.palette.primary.main)
              ? "primary"
              : "primary.contrastText"
          }
          sx={{ mr: !removeTitleSpace && 1 }}
          component="span"
        >
          {primaryText}
        </Typography>
        <Typography
          fontWeight="bold"
          variant="h6"
          color="#fff"
          component="span"
        >
          {secondaryText}
        </Typography>
        <Box>{children}</Box>
      </Box>
    </Box>
  );
};

export default ModalHeader;
